export default __webpack_public_path__ + "b0c7638e4ec2381dc3dc127f3a803258.png";